export const getMiniCartProducts = (state) => {
  return state.data.products || [];
};

export const getMiniCartTotalCount = (state) => {
  return state.data.totalProductCount || 0;
};

